import { Instagram, Youtube } from "lucide-react";
import { STREAMING } from "../lib/links";
import LetterReveal from "./LetterReveal";

const Spotify = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M7 9.5c3-1 7-1 10 .5" strokeLinecap="round" />
    <path d="M7.5 13c2.5-.8 5.5-.6 8 .8" strokeLinecap="round" />
    <path d="M8 16.2c2-.5 4.2-.4 6 .6" strokeLinecap="round" />
  </svg>
);

const AppleMusic = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" {...props}>
    <path d="M16 4l-7 1.4v10.6" strokeLinejoin="round" />
    <circle cx="7.5" cy="16" r="2" />
    <circle cx="14.5" cy="15" r="2" />
    <path d="M16 4v8" />
  </svg>
);

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" {...props}>
    <path d="M14 4v9.5a3.5 3.5 0 1 1-3.5-3.5" strokeLinecap="round" />
    <path d="M14 4c0 2.5 2 4.5 4.5 4.5" strokeLinecap="round" />
  </svg>
);

const socials = [
  { name: "Spotify", icon: Spotify, href: STREAMING.spotify },
  { name: "Apple Music", icon: AppleMusic, href: STREAMING.appleMusic },
  { name: "YouTube", icon: Youtube, href: STREAMING.youtube },
  { name: "Instagram", icon: Instagram, href: STREAMING.instagram },
  { name: "TikTok", icon: TikTok, href: STREAMING.tiktok },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-white border-t border-[#E6EAEF] pt-24 pb-10 px-6 md:px-12 lg:px-20 text-[#0A0A0A]"
    >
      <div className="max-w-[1500px] mx-auto">
        {/* Top row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 mb-20">
          <div className="overline">follow</div>
          <div className="flex items-center gap-8 md:gap-10">
            {socials.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.name}
                data-testid={`social-${s.name.toLowerCase().replace(/\s/g, "-")}`}
                className="group flex items-center gap-3 text-[#595959] hover:text-[#6B8FAE] transition-colors duration-400"
              >
                <s.icon className="w-5 h-5" />
                <span className="hidden md:inline font-mono-meta text-[10px] tracking-[0.3em] uppercase">
                  {s.name}
                </span>
              </a>
            ))}
          </div>
          <button
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            data-testid="footer-contact-link"
            className="font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C] hover:text-[#6B8FAE] link-underline transition-colors"
          >
            contact →
          </button>
        </div>

        {/* Huge artist name */}
        <div className="group select-none text-center mb-16 cursor-default">
          <h2
            data-testid="footer-huge-name"
            className="font-serif-display text-[18vw] md:text-[14vw] leading-[0.9] text-[#0A0A0A] tracking-tight"
          >
            <LetterReveal text="Sylas Ever" italicWords={["Sylas"]} stepMs={80} />
          </h2>
          <div className="mt-4 flex items-center justify-center gap-3 font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#6B8FAE] accent-pulse" />
            <span className="word-float">est. 2025</span>
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#6B8FAE] accent-pulse" style={{ animationDelay: "-1s" }} />
          </div>
        </div>

        {/* Bottom strip */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-t border-[#E6EAEF] pt-8">
          <div className="font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
            © {new Date().getFullYear()} Sylas Ever
          </div>
          <div className="flex items-center gap-2 font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#6B8FAE] blink" />
            <span>only you — out now</span>
          </div>
          <div className="flex items-center gap-5 font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
            <a href="#" className="hover:text-[#0A0A0A]" data-testid="footer-privacy">privacy</a>
            <a href="#" className="hover:text-[#0A0A0A]" data-testid="footer-terms">terms</a>
            <a href="#" className="hover:text-[#0A0A0A]" data-testid="footer-credits">credits</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
